import { render, staticRenderFns } from "./AlParagraph.vue?vue&type=template&id=11f62d60&scoped=true&"
import script from "./AlParagraph.vue?vue&type=script&lang=js&"
export * from "./AlParagraph.vue?vue&type=script&lang=js&"
import style0 from "./AlParagraph.vue?vue&type=style&index=0&id=11f62d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f62d60",
  null
  
)

export default component.exports